var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('cleave',{ref:'input',staticClass:"{comment} ant-input",attrs:{"options":{ numeral: true },"raw":true},on:{"keydown":function($event){return _vm.onKeyDown($event)}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }